import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AuthService } from '@y42/auth';
import { AuthQuery } from '@y42/auth/state';
import { environment } from '@y42/environment';
import { PushNotificationConfigService } from '@y42/push-notification';

@UntilDestroy()
@Injectable()
export class Y42PushNotificationConfigService implements PushNotificationConfigService {
  constructor(private readonly authQuery: AuthQuery, private readonly auth: AuthService) {}

  public readonly token$ = this.auth.selectToken();

  getAccessToken() {
    return this.authQuery.getAccessToken();
  }

  get authUrl() {
    return `${environment.url.ws_events_api}/broadcasting/auth`;
  }

  get pusherKey() {
    return environment.pusher.key;
  }

  get pusherCluster() {
    return environment.pusher.cluster;
  }
}
